export const ADMIN_ORGANIZATION_PROFILE_LIST_PATH = '/admin/organization/profiles';
export const ADMIN_ORGANIZATION_PROFILE_DETAIL_PATH = '/admin/organization/profiles/:profileId';
export const ADMIN_ORGANIZATION_PROFILE_GENERAL_PATH = '/admin/organization/profiles/:profileId/general';
export const ADMIN_ORGANIZATION_PROFILE_CONTACT_PATH = '/admin/organization/profiles/:profileId/contact';
export const ADMIN_ORGANIZATION_PROFILE_CONTACT_PERSONS_PATH =
    '/admin/organization/profiles/:profileId/contact-persons';
export const ADMIN_ORGANIZATION_PROFILE_JOBS_PATH = '/admin/organization/profiles/:profileId/jobs';
export const ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_PATH = '/admin/organization/profiles/:profileId/sessions';
export const ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_ADD_PATH =
    '/admin/organization/profiles/:profileId/sessions/add';
export const ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_EDIT_PATH =
    '/admin/organization/profiles/:profileId/sessions/:sessionId/edit';
